import { useLanguage } from "../i18n/LanguageContext";
const Footer = () => {
  const { t } = useLanguage();
  let currentYear = new Date().getFullYear();

  return (
    <div className="footer">
      <p className="copyright">{t("common.name")} &copy; {currentYear}</p>
    </div>
  );
};

export default Footer;
